import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, Typography } from '@mui/material';
import InfoBanner from 'src/shared/components/InfoBanner';
import { InlineLinkWrapper } from './styles';
import { useTranslation } from 'react-i18next';

export const InfoBannerWithLink = ({ guideUrl }: { guideUrl: string }) => {
  const { t } = useTranslation('settings');
  return (
    <InfoBanner Icon={false}>
      <Box display="flex" alignItems="flex-start">
        <Box sx={{ height: '24px' }}>
          <FileDownloadIcon color="primary" sx={{ marginRight: '12px' }} />
        </Box>
        <Box>
          <Typography variant="body1">
            <InlineLinkWrapper target="_blank" href={guideUrl}>
              {t('integration.download the integration guide')}
            </InlineLinkWrapper>{' '}
            {t('integration.before starting in order to have all the necessary data')}
          </Typography>
        </Box>
      </Box>
    </InfoBanner>
  );
};
